const apis = {
  demo: {
    queryData: "/data/queryDemoData"
  },
  common: {
    queryEsData: "/data/queryEsData.jsp"
  },
  sys: {
    queryEventAttrMetas: '/zg/web/v2/data/queryEventAttrMetas',
    queryUserProps: "/zg/web/v2/appusergroup/getUserPropMeta",
    // queryEventGroup: "/zg/web/v2/data/queryEventMetasOfGroup",
    queryEventGroup: "/zg/web/v2/data/queryEventMetas",
    queryEventEnv: "/zg/web/v2/appusergroup/getEventEnvData",
    queryVersionList: "/queryVersionList/{appId}/{platform}",
    getCurrentUser: "/zg/web/v2/company/currentUser",
    delEvent: "/data/deleteEventMeta.jsp",
    editEvent: "/data/updateEventInfo.jsp",
    editEventProp: "/data/updateEventAttr.jsp",
    switchGroup: "/analysis/api/eventGroup/operateGroupRelations",
    upsertGroup: "/analysis/api/eventGroup/upsertEventGroup",
    deleteGroup: "/analysis/api/eventGroup/deleteEventGroup"
  },
  // 实时概览
  dataview: {
    getIgnoreConfig: "/api/dataview/ignores",
    getConfig: "/api/dataview/config",
    chartType: "/api/dataview/chart/type",
    getGeo: "/api/dataview/geo"
  },
  // 用户群
  userGroup: {
    query: "/zg/web/v2/userGroup/getAll"
  },
  // 通用分析
  analysis: {
    queryData: "/data/datalist.jsp",
    appUpdateTime: "data/appUpdateTime.jsp"
  },
  visualizer: {
    queryAndroidEvents: "/data/getEventsCode.jsp",
    queryEvents: "/v1/events/codeless/app/{{appId}}/platform/{{platform}}",
    applyEvents: "/v1/events/codeless",
    checkEventName: "/data/getEventName.jsp",
    applyAllEvents: "/data/createEventsCode.jsp"
  },
  userInfo: {
    getInfos: "/zg/web/v2/appuser/queryUserInfos",
    getSessions: "/zg/web/v2/appuser/sessions",
    getEventInfo: "/zg/web/v2/appuser/querySessionAttrInfos"
  }
};

export default apis
